/*
 * ESSENZ — Bewegung fuer sections/rxk-es-*.liquid.
 *
 * [data-es-szene]  klebende Buehne: --p = wie weit sie durchgescrollt ist
 * [data-es-lauf]   normales Element: --p = Weg durchs Fenster (0 unten rein, 1 oben raus)
 * [data-es-rein]   blendet einmal ein
 * [data-es-index]  Steinliste: Bild folgt dem Zeiger
 * Horizon scrollt ab 990px in .page-wrapper, daher scroll mit capture.
 */
(() => {
  if (window.__rxkEssenz) return;
  window.__rxkEssenz = true;

  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const start = () => {
    document.documentElement.classList.add('es-js');

    const rein = document.querySelectorAll('[data-es-rein]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((eintraege) => {
        for (const e of eintraege) if (e.isIntersecting) { e.target.classList.add('ist-drin'); io.unobserve(e.target); }
      }, { rootMargin: '0px 0px -12% 0px' });
      rein.forEach((el) => io.observe(el));
    } else {
      rein.forEach((el) => el.classList.add('ist-drin'));
    }

    if (ruhig) return;

    /* Steinindex: schwebendes Bild */
    if (window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {
      document.querySelectorAll('[data-es-index]').forEach((index) => {
        const schwebe = index.querySelector('.es-index__schwebe');
        if (!schwebe) return;
        const bilder = schwebe.querySelectorAll('img');
        let ziel = { x: 0, y: 0 }, jetzt = { x: 0, y: 0 }, laeuft = false;
        const folge = () => {
          jetzt.x += (ziel.x - jetzt.x) * 0.16;
          jetzt.y += (ziel.y - jetzt.y) * 0.16;
          schwebe.style.setProperty('--x', jetzt.x.toFixed(1) + 'px');
          schwebe.style.setProperty('--y', jetzt.y.toFixed(1) + 'px');
          if (Math.abs(ziel.x - jetzt.x) + Math.abs(ziel.y - jetzt.y) > 0.5) requestAnimationFrame(folge);
          else laeuft = false;
        };
        index.querySelectorAll('[data-es-zeile]').forEach((zeile, i) => {
          zeile.addEventListener('mouseenter', (e) => {
            if (!schwebe.classList.contains('ist-an')) { jetzt = { x: e.clientX, y: e.clientY }; }
            bilder.forEach((b, j) => b.classList.toggle('ist-aktiv', j === i));
            schwebe.classList.toggle('ist-an', Boolean(bilder[i] && bilder[i].getAttribute('src')));
          });
        });
        index.addEventListener('mousemove', (e) => {
          ziel = { x: e.clientX, y: e.clientY };
          if (!laeuft) { laeuft = true; requestAnimationFrame(folge); }
        });
        index.querySelector('.es-index__liste').addEventListener('mouseleave', () => schwebe.classList.remove('ist-an'));
      });
    }

    const szenen = [...document.querySelectorAll('[data-es-szene]')];
    const laeufe = [...document.querySelectorAll('[data-es-lauf]')];
    if (!szenen.length && !laeufe.length) return;

    let geplant = false;
    const rechne = () => {
      geplant = false;
      const vh = window.innerHeight;
      for (const s of szenen) {
        const r = s.getBoundingClientRect();
        const buehne = s.firstElementChild;
        const oben = parseFloat(getComputedStyle(buehne).top) || 0;
        const lauf = Math.max(1, r.height - buehne.offsetHeight);
        s.style.setProperty('--p', Math.min(1, Math.max(0, (oben - r.top) / lauf)).toFixed(4));
      }
      for (const el of laeufe) {
        const r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) continue;
        el.style.setProperty('--p', Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height))).toFixed(4));
      }
    };
    const plane = () => { if (!geplant) { geplant = true; requestAnimationFrame(rechne); } };
    rechne();
    window.addEventListener('scroll', plane, { passive: true, capture: true });
    window.addEventListener('resize', plane);
    window.addEventListener('load', plane);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
